import API_BASE_URL from './config';
import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import './MeritConfoShowAdmin.css';

function MeritConfoShowAdmin() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [show, setShow] = useState(null);
  const [entries, setEntries] = useState([]);
  const [isAdmin, setIsAdmin] = useState(false);

  useEffect(() => {
    const playerId = localStorage.getItem('playerId');
    if (!playerId) {
      navigate('/login');
      return;
    }

    fetch(`/players/${playerId}`)
      .then((res) => res.json())
      .then((data) => {
        if (data.role !== 'admin') {
          navigate('/login');
        } else {
          setIsAdmin(true);
        }
      })
      .catch((err) => {
        console.error('Error checking admin status:', err);
        navigate('/login');
      });

    fetch(`/merit-confo/shows/${id}`)
      .then((res) => res.json())
      .then((data) => setShow(data))
      .catch((err) => console.error('Error fetching show:', err));

    fetch(`/merit-confo/shows/${id}/entries`)
      .then((res) => res.json())
      .then((data) => setEntries(data))
      .catch((err) => console.error('Error fetching entries:', err));
  }, [id, navigate]);

  if (!isAdmin) {
    return <p style={{ textAlign: 'center', color: '#333' }}>Please log in as an admin.</p>;
  }

  return (
    <div className="merit-confo-admin-container">
      <h2>Manage iCON Merit-Confo Show</h2>
      {show ? (
        <div>
          <h3>{show.name}</h3>
          <p>Region: {show.region}</p>
          <p>Location: {show.location}</p>
          <p>Start Date: {new Date(show.startDate).toLocaleDateString()}</p>
          <p>End Date: {new Date(show.endDate).toLocaleDateString()}</p>
          <p>Status: {show.status}</p>
          <p>Venue: {JSON.stringify(show.venueElements)}</p>
          <h4>Entries</h4>
          {entries.length > 0 ? (
            <ul>
              {entries.map((entry) => (
                <li key={entry._id}>
                  {entry.dogId?.registeredName || 'Unknown Dog'} ({entry.class})
                </li>
              ))}
            </ul>
          ) : (
            <p>No entries yet.</p>
          )}
        </div>
      ) : (
        <p>Loading show...</p>
      )}
    </div>
  );
}

export default MeritConfoShowAdmin;